import rg4js from 'raygun4js';
import { ErrorHandler } from '@angular/core';

import { environment } from '../environments/environment';

rg4js('apiKey', environment.raygunApiKey);
rg4js('enableCrashReporting', true);
rg4js('enablePulse', true); // Enables Real User Monitoring

// Create a new ErrorHandler and report an issue straight to Raygun
export class RaygunErrorHandler implements ErrorHandler {
  handleError(e: any) {
    rg4js('send', {
      error: e
    });

    console.error(e);
  }
}
